import { camelizeKeys } from '@skytech/utils'

import { SUB_SERVICE_ORDER_STATUS } from '@/modules/subscriptions/constants'
import type {
  Subscription,
  SubscriptionExtended,
  EditSubscriptionPayload,
  CreateSubscriptionPayload,
} from '@/modules/subscriptions/subscription/types'
import {
  API_ROUTE_CARRIER_BYID,
  API_ROUTE_SUBSCRIPTION,
  API_ROUTE_SUBSCRIPTION_LIST,
  API_ROUTE_SUBSCRIPTION_RESEND_FORM,
  API_ROUTE_ONBOARDING_CANCEL,
} from '@/resources/api-routes'
import { get, post } from '@/util/auth'

const getIsPortingWaitingForUser = (sub: Subscription) =>
  sub.status === SUB_SERVICE_ORDER_STATUS.NEW &&
  sub.updated === sub.created &&
  !!sub.ssoaId &&
  !sub.businessSub

const subscriptionResources = {
  get: async (subscriptionId: number) => {
    const subscription = await get<unknown>(
      API_ROUTE_SUBSCRIPTION.replace(':subscriptionId', String(subscriptionId))
    )
    const parsedSubscription = camelizeKeys(subscription)

    return parsedSubscription as SubscriptionExtended
  },
  getList: async () => {
    const subscriptions = await get<unknown>(API_ROUTE_SUBSCRIPTION_LIST)
    const parsedSubscriptions = camelizeKeys(subscriptions) as Subscription[]

    const subs = parsedSubscriptions.map(sub => {
      const status = getIsPortingWaitingForUser(sub)
        ? SUB_SERVICE_ORDER_STATUS.WAITING_FOR_USER
        : sub.status
      return {
        ...sub,
        status,
      }
    })

    return subs as Subscription[]
  },

  // Mutations
  postSubscription: (payload: CreateSubscriptionPayload) =>
    post(API_ROUTE_SUBSCRIPTION_LIST, payload),

  editSubscription: ({
    subscriptionId,
    payload,
  }: {
    subscriptionId: number
    payload: EditSubscriptionPayload
  }) => post(API_ROUTE_SUBSCRIPTION.replace(':subscriptionId', String(subscriptionId)), payload),

  resendForm: (subscriptionId: number) =>
    post(API_ROUTE_SUBSCRIPTION_RESEND_FORM.replace(':subscriptionId', String(subscriptionId))),

  getCarrierById: async () => get<string>(API_ROUTE_CARRIER_BYID, true),

  cancelOnboardingOrder: async (id: number, comment: string) => {
    const order = await post<Subscription>(
      API_ROUTE_ONBOARDING_CANCEL.replace(':subscriptionId', String(id)),
      {
        comment,
      },
      true
    )
    return order
  },
}

export default subscriptionResources
